import React from "react";
import Helmet from "react-helmet";

export const SEO = ({ SEOTitle, SEODescription, SEOUrl }) => (
  <Helmet>
    <title>{SEOTitle}</title>
    <meta charSet="utf-8" />
    <link rel="canonical" href={SEOUrl} />
    <meta name="description" content={SEODescription} />
    
    {/* Open Graph metadata */}
    <meta property="og:title" content={SEOTitle} />
    <meta property="og:description" content={SEODescription} />
    <meta property="og:url" content={SEOUrl} />

    {/* Twitter metadata */}
    <meta property="twitter:title" content={SEOTitle} />
    <meta property="twitter:description" content={SEODescription} />
    <meta property="twitter:url" content={SEOUrl} />
  </Helmet>
);



// WEBPACK FOOTER //
// ./src/components/SEO.jsx